import type { Price, PriceInterval } from '../types';

/**
 * Converts a price in cents to its weekly equivalent.
 * Returns null for non-recurring intervals (one-time, donation).
 */
export const convertToWeeklyPrice = (amountCents: number, interval: PriceInterval): number | null => {
  switch (interval) {
    case 'month':
      return (amountCents * 12) / 52;
    case 'quarter':
      return amountCents / 13;
    case 'year':
      return amountCents / 52;
    default:
      return null;
  }
};

/**
 * Computes weekly display prices for a given price selection.
 * Returns null values when weekly pricing is disabled or not applicable.
 */
export const getWeeklyPriceDisplay = ({
  enabled,
  price,
  displayCents,
  isDiscounted,
  isPaidTrial,
}: {
  enabled: boolean;
  price: Price | undefined;
  displayCents: number | undefined;
  isDiscounted: boolean;
  isPaidTrial: boolean;
}): { weeklyCents: number | null; weeklyOriginalCents: number | null } => {
  const isDonation = price?.interval === 'donation';

  if (!enabled || !price || isPaidTrial || isDonation || displayCents == null) {
    return { weeklyCents: null, weeklyOriginalCents: null };
  }

  return {
    weeklyCents: convertToWeeklyPrice(displayCents, price.interval),
    weeklyOriginalCents: isDiscounted ? convertToWeeklyPrice(price.original_amount_cents, price.interval) : null,
  };
};
